import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { getUsersAll, getUsersByDates, getUsersByType } from '../../redux/actions/UsersActions'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import { IoIosArrowDown } from 'react-icons/io'
import moment from 'moment'
import { UPDATE_META } from '../../redux/Types'

const userTypes = ['All', 'Customers', 'Vendors', 'Riders']

const AllUsersFilter = () => {
    const [showUserType, setShowUserType] = useState(false)
    const [showDate, setShowDate] = useState(false)
    const dispatch = useDispatch()
    const [value, onChange] = useState([new Date(), new Date()]);
    const [selectedType, setSelectedType] = useState(null)

    const toggleUserType = () => {
        setShowUserType(prevState => !prevState)
    }
    const toggleDate = () => {
        setShowDate(prevState => !prevState)
    }

    let selectedUser = null

    const toggleTabs = (val) => {
        setSelectedType(val)
        selectedUser = val
        dispatch(getUsersByType(selectedUser))
        console.log(val)
        toggleUserType()
        dispatch({ type: UPDATE_META, payload: val })

    }
    console.log(selectedType)

    const renderTabs = () => {
        return userTypes?.map((item, index) => {
            return (
                <li key={index} className={`filterListItem boldText f14`} onClick={() => toggleTabs(item)}>{item}</li>
            )
        })
    }

    let start_date = null
    let end_date = null
    const getUsersByDate = () => {
        if (value) {
            start_date = moment(value[0]).format('YYYY-MM-DD')
            end_date = moment(value[1]).format('YYYY-MM-DD')
            // console.log(start_date, end_date)
            dispatch(getUsersByDates(selectedType, start_date, end_date))
            toggleDate()
        }
    }



    return (

        <>

            <section className={'flexRow alignCenter'} style={{ marginTop: '20px' }}>
                <div style={{ position: 'relative', cursor: "pointer" }}>
                    <div className={'filterDropContainer flexRow alignCenter justifyCenter'} onClick={toggleUserType}>

                        <p className={'f16 semiBoldText'} style={{ color: '#919294' }}>User-type</p>
                        <IoIosArrowDown color={'#919294'} />
                    </div>
                    {showUserType && <ul className={'filterListContainer'}>
                        {renderTabs()}
                    </ul>}
                </div>
                <div style={{ position: 'relative', cursor: "pointer" }}>
                    <div className={'filterDropContainer flexRow alignCenter justifyCenter'} onClick={toggleDate}>

                        <p className={'f16 semiBoldText'} style={{ color: '#919294' }}>Date Joined</p>
                        <IoIosArrowDown color={'#919294'} />
                    </div>
                    {showDate && <DateRangePicker onChange={onChange} value={value} onCalendarClose={getUsersByDate} calendarType='Hebrew' />}
                </div>
            </section>
        </>
    )
}

export default AllUsersFilter



